import React from 'react'
import X from "./images/x1.png"
import IG from "./images/ig.jpg"
import fb from "./images/fb.jpg"
import tg from "./images/tg.png"

const footer = () => {
  return (
    <div className='footer'>
      
      <div className="social-media-links">
        <h2>Follow us on Social Media:</h2>
        {/* Add links to your social media handles */}
        <a href="https://x.com/TheCricketerBro" target="_blank" rel="noopener noreferrer">
          <img src={X} alt="x" />
        </a>
        <a href="https://instagram.com/the_cricketers_bro?igshid=OGQ5ZDc2ODk2ZA/" target="_blank" rel="noopener noreferrer">
        <img src={IG} alt="x" />
        </a>
        <a href="https://www.facebook.com/TheCricketerBro/" target="_blank" rel="noopener noreferrer">
        <img src={fb} alt="x" />
        </a>
        <a href="https://t.me/The_Cricketer_Bro" target="_blank" rel="noopener noreferrer">
        <img src={tg} alt="x" />
        </a>
        
        <div>Devloped by:-
        <a href="https://t.me/webdevloper_7" target="_blank" rel="noopener noreferrer" ><h2>Webdevloper</h2> </a>
      </div>
      </div>
     
    </div>
  )
}

export default footer